// extracted by mini-css-extract-plugin
export const trackPreview = "track-preview-module--track-preview--2VI4u";
export const header = "track-preview-module--header--5mbqN";
export const titleColumn = "track-preview-module--title-column--2w2ZB";
export const difficultyColumn = "track-preview-module--difficulty-column--28ekz";
export const title = "track-preview-module--title--14ik2";
export const content = "track-preview-module--content--2BHiz";
export const surfaceFacts = "track-preview-module--surface-facts--3CxgD";
export const coreFacts = "track-preview-module--core-facts--3LuAz";